<script>
    import { onMount, createEventDispatcher } from "svelte";
    import Button from "../buttons/Button.svelte";
    import Checkbox from "../Checkbox.svelte";
    import Modal from "../Modal.svelte";
    import { cConsentStatus, cConsentStore } from "./c-consent.store";
    import { cTypes } from "./cs";
    export let step = undefined; //"manage";
    export let forceOpen = false;
    let mounted = false;

    const dispatch = createEventDispatcher();

    onMount(() => {
        cConsentStore.readSync();
        mounted = true;
    });

    function done() {
        dispatch("done");
    }

    let accepted = Object.entries($cConsentStore.types)
        .filter(([_, val]) => val !== cConsentStatus.REJECTED)
        .map(([name]) => name);
    $: rejected = Object.keys($cConsentStore.types).filter((type) => !accepted.includes(type));

    /**
     *
     * @param {string} which
     */
    function toggleChoice(which) {
        if (accepted.includes(which)) {
            accepted = accepted.filter((name) => name !== which);
            return;
        }
        accepted = accepted.concat(which);
    }
</script>

{#if (mounted && $cConsentStore.hasUnknown) || forceOpen}
    <Modal>
        <div class="flex flex-col flex-nowrap w-full fixed top-[10%] px-4 py-4 justify-center items-center">
            <div
                role="alertdialog"
                aria-label="Användning av kakor på nylandersmattor.se"
                class="bg-[#edeff1] flex flex-row flex-wrap items-center w-full md:w-2/3 xl:w-1/2 px-8 py-6 gap-8 rounded-md"
            >
                {#if !step}
                    <div class="w-full text-sm">
                        <h5 class="text-lg font-bold mb-2">Vi bryr oss om din integritet</h5>
                        <p>
                            Genom att klicka på "acceptera alla" samtycker du till lagring av kakor på din enhet för att
                            lagra produkter i kundvagnen, analysera webbplatsens användning samt för att personanpassa
                            vår annonsering. Läs mer i vår
                            <a class="text-blue-700 underline" target="_blank" href="/cookie-policy">Cookiepolicy</a>.
                        </p>
                    </div>
                    <div class="mx-auto my-4 md:my-0 flex flex-col-reverse flex-nowrap gap-6 sm:flex-row">
                        <Button border={false} dark on:click={() => (step = "manage")}
                            ><span class="text-blue-700 underline text-sm font-medium">Hantera cookies</span></Button
                        >
                        <Button
                            on:click={() => {
                                cConsentStore.acceptAll();
                                done();
                            }}
                            primary
                            ariaLabel="Acceptera alla"
                        >
                            Acceptera alla
                        </Button>
                    </div>
                {:else if step === "manage"}
                    <div class="max-h-[70vh] overflow-auto">
                        <div>
                            <h5 class="text-lg font-bold mb-2">Inställningscenter för integritet</h5>
                            När du besöker en webbplats kan den lagra eller hämta information i din webbläsare, främst i
                            form av cookies. Den här informationen kan vara om dig, dina preferenser, eller din enhet och
                            används mestadels för att webbplatsen ska fungerar som du förväntar dig.
                            <br />Informationen identifierar dig vanligtvis inte direkt, men den kan ge dig en mer
                            personlig webbupplevelse. Eftersom vi respekterar din rätt till integritet, kan du välja att
                            inte tillåta vissa typer av cookies.
                            <br />Klicka på de olika kategorierna för att läsa mer och ändra våra standardinställningar.
                            Att blockera vissa typer av cookies kan dock påverka din upplevelse av webbplatsen och de
                            tjänster som vi kan erbjuda.
                            <br />
                            Läs mer i vår
                            <a class="text-blue-700 underline" target="_blank" href="/cookie-policy">Cookiepolicy </a>
                        </div>
                        <div class="flex flex-row justify-start mt-4">
                            <Button
                                on:click={() => {
                                    cConsentStore.acceptAll();
                                    done();
                                }}
                                primary
                                ariaLabel="Tillåt alla"
                            >
                                Tillåt alla
                            </Button>
                        </div>
                        <div class="mt-4">
                            <h5 class="text-lg font-bold mb-2">Hantera inställningar för samtycke</h5>
                            <div>
                                <div class="min-h-20 w-full border border-gray-300 rounded-md">
                                    {#each Object.values(cTypes) as cookieType}
                                        <details>
                                            <summary class="cursor-pointer">
                                                <div class="flex flex-row w-full p-4">
                                                    <div>{cookieType.name}</div>
                                                    <div class="ml-auto">
                                                        {#if !cookieType.editable}
                                                            <span class="text-blue-700">Alltid aktiv</span>
                                                        {:else}
                                                            <Checkbox
                                                                on:click={() => toggleChoice(cookieType.id)}
                                                                selected={accepted.includes(cookieType.id)}
                                                            />
                                                        {/if}
                                                    </div>
                                                </div>
                                            </summary>
                                            <div class="bg-gray-300 p-4">
                                                {cookieType.description}
                                            </div>
                                        </details>
                                    {/each}
                                </div>
                                <div class="flex flex-row justify-end mt-4">
                                    <Button
                                        on:click={() => {
                                            cConsentStore.setStatus(accepted, rejected);
                                            done();
                                        }}
                                        primary
                                        ariaLabel="Spara mina val"
                                    >
                                        Spara mina val
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </Modal>
{/if}

<style>
    details > summary {
        list-style: none;
    }
    details > summary::-webkit-details-marker {
        display: none;
    }
</style>
